import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

/**
 * A real QR code component that generates an actual QR code from provided text
 * @param {string} text - The text to encode in the QR code
 * @param {string} className - CSS classes to apply to the container
 * @param {string} color - The color of the QR code (default: black)
 * @param {string} bgColor - The background color (default: white)
 * @param {number} size - Size in pixels (will be constrained by container)
 * @param {number} level - Error correction level: 'L', 'M', 'Q', 'H' (default: 'M')
 */
const ActualQrCode = ({
  text = '<qr>Coming soon TM</qr>',
  color = '#000000',
  bgColor = '#FFFFFF',
  size = 162,
  level = 'M',
}) => {
  return (
    <div className='qrContainer flex justify-center items-center'>
      <QRCodeSVG
        value={text}
        size={size}
        level={level}
        fgColor={color}
        bgColor={bgColor}
      />
    </div>
  );
};

export default ActualQrCode;
